/**
 * TEMPORARY: Hook to load test guided study fixture for comprehensive capability testing
 * 
 * This hook loads a manually-created guided study that exercises ALL capabilities
 * in the Bible Glen app, allowing us to test the capability modal and guided study
 * features comprehensively.
 * 
 * TO USE:
 * 1. Set ENABLE_TEST_GUIDED_STUDY = true below
 * 2. Navigate to passage GuS3QMpu0CfkSjzgA9C8 (Philemon 1:1-7)
 * 3. Start the guided study
 * 4. Test all capability buttons
 * 
 * TO DISABLE:
 * Set ENABLE_TEST_GUIDED_STUDY = false
 */

import { useState, useEffect } from 'react';

// 🔧 TOGGLE THIS TO ENABLE/DISABLE TEST FIXTURE
export const ENABLE_TEST_GUIDED_STUDY = false;

// The passage ID that has the test fixture
export const TEST_PASSAGE_ID = 'GuS3QMpu0CfkSjzgA9C8';

export function useTestGuidedStudy(passageId: string, personaId: string) {
  const [testData, setTestData] = useState<GuidedStudyByPassage | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!ENABLE_TEST_GUIDED_STUDY || passageId !== TEST_PASSAGE_ID) {
      setTestData(null);
      setIsLoading(false);
      return;
    }

    // Load the test fixture
    fetch('/test-fixtures/comprehensive-guided-study-philemon.json')
      .then(res => res.json())
      .then(data => {
        // Transform the fixture into the expected GuidedStudyByPassage format
        const studies: GuidedStudy[] = Object.entries(data.personas).map(([personaId, personaData]: [string, any]) => ({
          personaId,
          title: personaData.title,
          hook: personaData.hook,
          primaryMethods: personaData.primaryMethods,
          steps: personaData.steps
        }));

        const guidedStudyByPassage: GuidedStudyByPassage = {
          id: `test-${data.passageId}`,
          passageId: data.passageId,
          book: 'PHM',
          version: 1,
          dateCreated: new Date(),
          dateUpdated: new Date(),
          studies
        };
        setTestData(guidedStudyByPassage);
        setIsLoading(false);
        console.log('🧪 TEST FIXTURE LOADED:', guidedStudyByPassage);
      })
      .catch(err => {
        console.error('Failed to load test fixture:', err);
        setTestData(null);
        setIsLoading(false);
      });
  }, [passageId, personaId]);

  return {
    testData,
    isLoading,
    isTestMode: ENABLE_TEST_GUIDED_STUDY && passageId === TEST_PASSAGE_ID
  };
}

